import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const GuideRailLogoImage = styled.img<React.CSSProperties>`
  width: ${Screen.widthRatio * 90}px;
  display: block;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

export default withImage(GuideRailLogoImage);
